import { InjectionToken } from '@angular/core';

export const ROOT_ASSET_OBIDS = new InjectionToken<string[]>(
  'ROOT_ASSET_OBIDS',
  { factory: () => ['517'] },
);
